import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("监控报警")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("   ")

import {ref, onMounted, reactive, watch} from "vue";
import Datatable from "@/components/kt-datatable/Datatable3.vue";
import ApiService from "@/core/services/ApiService";


export default /*#__PURE__*/_defineComponent({
  props: {
  tab: { type: String, required: true },
},
  setup(__props) {

const props = __props



const dataT = ref<HTMLElement | null>(null);
const apiUrl = 'm/collection/monitoring';
const d = new Date();
d.setDate(d.getDate() - 7);
const tableHeader = ref([
  { name: "ID", key: "id", width: '60' },
  { name: "报警内容", key: "content", align: 'left' },
]);
const filters = reactive({
  key: '',
  source: '',
  position: '',
});
const collection = ref<any>({});  // 当前站点的模块列表

onMounted(() => {
});

watch(props, (val) => {
  if (props.tab === '栏位监控'){
    loadData();
  }
});

const loadData = () => {
  (dataT as any).value.setCurrent(1);
}

const loadHeader = (func) => {
  return true;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Datatable, {
    ref_key: "dataT",
    ref: dataT,
    apiUrl: apiUrl,
    "table-header": tableHeader.value,
    filters: _unref(filters),
    title: "栏位监控",
    actionMenu: false,
    preLoad: loadHeader,
    "enable-items-per-page-dropdown": false
  }, {
    search: _withCtx(() => [
      _hoisted_1
    ]),
    toolbar: _withCtx(() => [
      _hoisted_2
    ]),
    _: 1
  }, 8, ["table-header", "filters"]))
}
}

})